var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1040,
    height: 1137,
    viewBox: "0 0 1040 1137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 626.5,
    cy: 723.5,
    r: 413.5,
    fill: "#6378E4",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 625,
    cy: 719,
    r: 365,
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219,
    cy: 206,
    r: 206,
    fill: "#6378E4",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218,
    cy: 204,
    r: 182,
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 616,
    r: 70,
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 624.5,
    cy: 723.5,
    r: 386.5,
    fill: "white",
    fillOpacity: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircles);
export default __webpack_public_path__ + "static/media/circles.f0c33d6786473a9a9cec140fee3d1103.svg";
export { ForwardRef as ReactComponent };